import { EmirateID, PlanCategory, PolicyType, Relationship, isEmirateCountry } from '../../../common';

export function showUploadLabourContractScan(
	policyType: PolicyType | undefined,
	relationshipTypeId: number | undefined,
	planCategory: PlanCategory | undefined,
	isSponsorLaborContractRequired?: boolean
) {
	if (planCategory === PlanCategory.Enhanced) {
		return false;
	}

	if (policyType !== PolicyType.DomesticWorker && relationshipTypeId === Relationship.Self) {
		return true;
	}

	if (policyType === PolicyType.DomesticWorker && relationshipTypeId === Relationship.Self) {
		return isSponsorLaborContractRequired;
	}

	if (policyType === PolicyType.DomesticWorker && relationshipTypeId === Relationship.DomesticWorker) {
		return true;
	}

	return false;
}

export function showInsuranceConinuityUpload(policyType?: PolicyType, isPrinciple?: boolean, emiratesId?: number) {
	if (isPrinciple && (policyType === PolicyType.OnlyFamily || policyType === PolicyType.DomesticWorker)) return false;

	return emiratesId === EmirateID.AbuDhabi;
}

export function showOccupationField(policyTypeId?: PolicyType, relationshipTypeId?: number) {
	if (policyTypeId === PolicyType.OnlyFamily && relationshipTypeId === Relationship.Self) {
		return false;
	}

	if (policyTypeId === PolicyType.DomesticWorker && relationshipTypeId === Relationship.Self) {
		return false;
	}

	return true;
}

export function includeSalaryBandField(relationshipTypeId: number | undefined) {
	return relationshipTypeId === Relationship.Self || relationshipTypeId === Relationship.DomesticWorker;
}

export function disableSalaryBandField(policyType: PolicyType | undefined, relationshipTypeId: number | undefined) {
	return (
		policyType !== PolicyType.DomesticWorker ||
		(policyType === PolicyType.DomesticWorker && relationshipTypeId === Relationship.DomesticWorker)
	);
}

export function includeVisaFileNumberField(country?: { id?: number; isGCC?: boolean }) {
	return !isEmirateCountry(country?.id) && !country?.isGCC;
}
